import { PersonalModuleRoutes } from '@app/modules/personal/personal-routes';
import { PersonalAuthGuard } from '@app/core/guards/personal-auth.guard';
import { MyAccountComponent } from '@app/modules/personal/pages/my-account/my-account.component';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export const personalRoutes: Routes = [
    { path: PersonalModuleRoutes.MY_ACCOUNT, component: MyAccountComponent, canActivate: [PersonalAuthGuard], data: { breadcrumb: marker('personal.my_account.breadcrumb') }  }
];

export const personalRouting = RouterModule.forChild(personalRoutes);

@NgModule({
    imports: [personalRouting],
    exports: [RouterModule]
})
export class PersonalRoutingModule { }
